
import React from "react";
import PageSelectionDialog from "@/components/shared/PageSelectionDialog";

interface TimetablePageSelectionDialogProps {
  isOpen: boolean;
  onClose: () => void;
  totalRecords: number;
  recordsPerPage: number;
  onDownload: (startPage: number, endPage: number) => void;
  reportTitle: string;
}

const TimetablePageSelectionDialog = ({ 
  isOpen, 
  onClose, 
  totalRecords, 
  recordsPerPage,
  onDownload,
  reportTitle
}: TimetablePageSelectionDialogProps) => {
  return (
    <PageSelectionDialog
      isOpen={isOpen}
      onClose={onClose}
      totalRecords={totalRecords}
      recordsPerPage={recordsPerPage}
      onDownload={onDownload}
      reportTitle={reportTitle}
    />
  );
};

export default TimetablePageSelectionDialog;
